import {
  Component,
  OnInit,
  ViewChild,
} from '@angular/core';
import { PhotoService } from '../services/photo.service';
import { IonModal, ToastController } from '@ionic/angular';
import { AuthenticatorService } from '@aws-amplify/ui-angular';
import { fetchAuthSession } from 'aws-amplify/auth';
import { GlobalService } from '../services/global.service';
import { HttpClient } from '@angular/common/http';
import MainScene from '../Scenes/MainScene';

@Component({
  selector: 'app-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.scss'],
})
export class FileUploaderComponent implements OnInit {
  @ViewChild(IonModal) modal: IonModal;
  photos$ = PhotoService.photos$;
  public photoService: PhotoService;
  isMainScene = false;

  constructor(
    private toastController: ToastController,
    public authenticator: AuthenticatorService,
    public globalService: GlobalService,
    private http: HttpClient,
  ) { 
    this.photoService = new PhotoService(http)
  }

  async ngOnInit() {
    console.log('file-uploader.component.ts ngOnInit called');
    
    // Check if current scene is MainScene
    GlobalService.$activeScenes.subscribe(scenes => {
      this.isMainScene = scenes.some(scene => scene instanceof MainScene);
    });

    this.globalService.$loggedIn.subscribe({
      next: async loggedIn => {
        if(loggedIn){
          const session = await fetchAuthSession();
          const identityId = session.identityId;
          if(identityId && this.authenticator.user && this.authenticator.user.username){
            PhotoService.identityId = identityId;
            PhotoService.username = this.authenticator.user.username;
            PhotoService.syncImages();
          }
        }
      },
      error: async error => {
        console.error('There was an error retrieving photo data!', error);

        const toast = await this.toastController.create({
          message: 'There was an error retrieving your photos!',
          duration: 1500,
          color: 'warning',
          position: 'top',
        });
        await toast.present();
      }
    })
  }

  uploadImage() {
    this.photoService.pickPicture();
  }

  async uploadImageClicked() {
    if (this.isMainScene) {
      this.uploadImage();
    } else {
      const toast = await this.toastController.create({
        message: "You can't upload images in levels.",
        duration: 2000,
        color: 'warning',
        position: 'top',
      });
      await toast.present();
    }
  }

  cancel() {
    this.modal.dismiss(null, 'cancel');
  }
}
